import React from "react";

import { Button, Grid, IconButton } from "@tiny/components";
import PageHeader from "@tiny/components/src/PageHeader";
import SegmentSummaryDialog from "../../../components/SegmentSummaryDialog";
import InfoOutline from "@tiny/icons/generated/InfoOutline";
import { useViewSegmentHeader } from "./ViewSegmentHeader.hooks";

function ViewSegmentHeader() {
  return <ViewSegmentHeaderComponent {...useViewSegmentHeader()} />;
}

const ViewSegmentHeaderComponent = React.memo(
  (props: ReturnType<typeof useViewSegmentHeader>) => {
    const {
      nameEditing,
      editName,
      saveName,
      mdUp,
      segmentName,
      cancelEditName,
      isLoading,
      isSegmentLoading,
      editSegment,
      summaryOpen,
      openSummary,
      closeSummary,
      filter,
      openSaveAs,
      isPredefined,
      editDisabled,
      editDisabledTooltip,
    } = props;

    return (
      <>
        <PageHeader
          mb={mdUp ? 6 : 0}
          backUrl={`/main/audience?tab=${
            isPredefined ? "predefined_segments" : "custom_segments"
          }`}
          onTitleCancel={cancelEditName}
          onTitleEdit={editName}
          onTitleSave={saveName}
          title={isSegmentLoading ? "-" : segmentName}
          titleEditLabel="Segment name"
          titleEditable={!isSegmentLoading && !editDisabled}
          titleEditing={nameEditing}
          titleSaving={isLoading}
          titleMaxLength={140}
          hideRefresh
          actions={
            mdUp ? (
              <Grid container spacing={5} alignItems="center">
                <Grid item>
                  <Button
                    variant={isPredefined ? "text" : "contained"}
                    noPadding={isPredefined}
                    onClick={editSegment}
                    disabled={editDisabled}
                    disabledTooltip={editDisabledTooltip}
                  >
                    Edit
                  </Button>
                </Grid>
                {isPredefined && (
                  <Grid item>
                    <Button variant="contained" onClick={openSaveAs}>
                      Save as
                    </Button>
                  </Grid>
                )}
              </Grid>
            ) : (
              <IconButton size="small" onClick={openSummary}>
                <InfoOutline />
              </IconButton>
            )
          }
        />
        <SegmentSummaryDialog
          open={summaryOpen}
          onClose={closeSummary}
          filter={filter}
          hideRefresh
        />
      </>
    );
  }
);

export default ViewSegmentHeader;
